import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as _ser from "../../../_redux/_services/ProjectsSlice";
import GetJobId from "../../../_utilities/GetJobId";
import ProjectsComponent from "../ProjectsComponent";
import { Box } from "@mui/material";
import FloatingMenu from "../../../components/FloatingMenu/FloatingMenu";
import { ProjectViewfloatingMenuOptions } from "../../../constants/floatingMenuConstants";
import { useNavigate } from "react-router-dom";

const initalState = { data: null, message: "", isloader: true };

const ProjectsView = () => {
  const getJobCode = GetJobId();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [projectDetails, setProjectDetails] = useState(null);
  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  const showLoader = useSelector((state) => state.Loader.value);
  const showUncommonLoader = useSelector((state) => state.UncommonLoader.value);

  useEffect(() => {
    if (getJobCode) {
      GetData(getJobCode);
    }
  }, [getJobCode]);

  const projectDetailsResponse = useSelector(
    (state) => state.GetProjectsById.data,
  );

  const GetData = async (getJobCode) => {
    dispatch(_ser.getProjectsByIdAsync(getJobCode));
  };

  useEffect(() => {
    if (projectDetailsResponse !== null && projectDetailsResponse.length > 0) {
      let projectData = JSON.parse(JSON.stringify(projectDetailsResponse));
      projectData[0].accessibleTo =
        JSON.parse(projectData[0].accessibleTo) || [];
      setProjectDetails(projectData[0]);
      dispatch(_ser.getProjectsByIdStartReducer(initalState));
    }
  }, [projectDetailsResponse]);

  const handleReceiveActionHandler = (type) => {
    if (type === "edit") {
      navigate(`/ats/layout/projects/edit/${getJobCode}`);
    }
  };

  return (
    <Box sx={{ padding: "0 10px" }} id="projectsView">
      {projectDetails?.name !== "" ? (
        <ProjectsComponent
          componentType="view"
          actions={[]}
          headerAction={
            <div style={{ position: "relative", right: "-33%" }}>
              <FloatingMenu
                floatingMenuOptions={ProjectViewfloatingMenuOptions}
                onReceiveActionHandler={handleReceiveActionHandler}
                storedTheme={storedTheme}
              />
            </div>
          }
          onValidData={() => {}}
          input={projectDetails}
        />
      ) : (
        !showLoader &&
        !showUncommonLoader && (
          <div className="nodatasection">
            <img
              src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
              alt="noData"
            />
            {"No data found"}
          </div>
        )
      )}
    </Box>
  );
};

export default ProjectsView;
